<template>
  <div>
    <div class="card card-custom">
      <div
        class="card-header"
        style="position: sticky; top: 104px; z-index: 999"
      >
        <h3
          class="mt-1 mb-4 text-primary title fw-bold standar-plus"
          v-if="!customCobs"
        >
          Selecciona el paquete
        </h3>

        <h6
          class="text-primary title fw-bold responsive-plus"
          v-if="!customCobs"
        >
          Selecciona el paquete
        </h6>

        <h3
          class="mt-1 mb-4 text-primary title fw-bold standar-plus"
          v-if="customCobs"
        >
          Personaliza su paquete
        </h3>

        <h5
          class="mt-1 mb-4 text-primary title fw-bold responsive-plus"
          v-if="customCobs"
        >
          Personaliza su paquete
        </h5>

        <div class="row d-flex align-items-center">
          <div class="col-md-1 text-center icon-car">
            <img :src="myIcon" alt="Icono" class="img-fluid" />
          </div>
          <div class="col-md-3">
            <span
              class="fw-bold title font-label standar-plus"
              style="color: #003b71 !important"
            >
              {{ payload.submarca }},
              {{ payload.versionText }}
            </span>
          </div>
          <div class="col-md-8 col-sm-12 mt-3" v-if="!customCobs">
            <div class="row standar-plus">
              <CardRadioPlan
                class="wizard__card__selection card__cobs pt-4"
                v-for="(paq, i) in allCobs"
                :key="i"
                :price="`$${formatMoney(paq.TOTALPAQUETE)}`"
                :pricesub="`$ 0 MXN`"
                :title="paq.PAQUETE"
                :subtitle="''"
                :model="paq.MODEL"
                :changePlan="changePackage"
                :index="i"
              />
            </div>
            <div class="table-responsive responsive-plus">
              <table>
                <tr>
                  <td v-for="(paq, i) in allCobs" :key="i">
                    <CardRadioPlan
                      class="mt-2"
                      :price="`$${formatMoney(paq.TOTALPAQUETE)}`"
                      :pricesub="`$ 0 MXN`"
                      :title="paq.PAQUETE"
                      :subtitle="''"
                      :model="paq.MODEL"
                      :changePlan="changePackage"
                      :index="i"
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="col-md-8 col-sm-12 mt-3 standar-plus" v-if="customCobs">
            <div class="row align-items-center">
              <div class="col-md-5">
                <CardRadioPlan
                  class="wizard__card__selection card__cobs"
                  v-for="(paq, i) in getCobSelect()"
                  :key="i"
                  :price="`$${formatMoney(paq.TOTALPAQUETE)}`"
                  :pricesub="`$ 0 MXN`"
                  :title="paq.PAQUETE"
                  :subtitle="''"
                  :model="paq.MODEL"
                  :changePlan="changePackage"
                  :index="i"
                />
              </div>
              <h2 class="col-md-1 title-custom text-center">+</h2>
              <div class="col-md-5">
                <div
                  class="card card-plan shadow-sm bg-secondary text-center pt-3"
                  style="background-color: #003b71 !important"
                >
                  <div class="card__title m-3">
                    <p class="text-dark fw-bold">
                      <span
                        style="
                          color: white !important;
                          font-size: 12px !important;
                        "
                        >Protección extra personalizada</span
                      >
                    </p>
                    <h3
                      style="
                        color: white !important;
                        font-size: 15px !important;
                      "
                      v-for="(paq, i) in getCobSelect()"
                      :key="i"
                    >
                      ${{ formatMoney(paq.TOTALCOBEXTRA) }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row responsive-plus" v-if="customCobs">
            <div class="col-md-12">
              <div class="table-responsive pt-2 ml-2">
                <table>
                  <tr>
                    <td>
                      <CardRadioPlan
                        class=""
                        v-for="(paq, i) in getCobSelect()"
                        :key="i"
                        :price="`$${formatMoney(paq.TOTALPAQUETE)}`"
                        :pricesub="`$ 0 MXN`"
                        :title="paq.PAQUETE"
                        :subtitle="''"
                        :model="paq.MODEL"
                        :changePlan="changePackage"
                        :index="i"
                      />
                    </td>
                    <td><h2 class="title-custom ml-1 mr-2">+</h2></td>
                    <td>
                      <div
                        class="
                          card card-plan
                          shadow-sm
                          bg-secondary
                          text-center
                          p-1
                          w-100
                        "
                        style="background-color: #003b71 !important"
                      >
                        <div class="card__title">
                          <p class="text-dark fw-bold">
                            <span
                              style="
                                color: white !important;
                                font-size: 12px !important;
                              "
                              >Protección extra</span
                            >
                          </p>
                          <h3
                            style="
                              color: white !important;
                              font-size: 15px !important;
                            "
                            v-for="(paq, i) in getCobSelect()"
                            :key="i"
                          >
                            ${{ formatMoney(paq.TOTALCOBEXTRA) }}
                          </h3>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body p-4">
        <div v-if="!customCobs">
          <div v-for="(paq, ind) in allCobs" :key="ind" class="mb-4">
            <div v-if="paq.MODEL">
              <div
                class="accordion accordion-flush"
                :id="`accordionFlush${ind}`"
                v-if="paq.MODEL"
              >
                <div v-for="(cob, c) in paq.COBERTURAS" :key="c">
                  <div class="accordion-item" v-if="cob.OPCIONAL === 0">
                    <h2 class="accordion-header" :id="`flush-heading${c}`">
                      <button
                        class="accordion-button collapsed row"
                        type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="`#flush-collapse${c}`"
                        aria-expanded="false"
                        :aria-controls="`flush-collapse${c}`"
                      >
                        <div class="col-md-4 col-sm-12">
                          <div class="round mb-3">
                            <input
                              :id="`checkbox${c}`"
                              type="checkbox"
                              name="active"
                              v-model="cob.check"
                              @change="calculateCob($event, c)"
                              :disabled="cob.NOMENCLATURA !== 'AI'"
                            />
                            <label
                              :for="`checkbox${c}`"
                              class="label-checkbox"
                            ></label>
                            <label class="label-text">{{
                              cob.DESCRIPCIONCOBERTURA
                            }}</label>
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-12 mt-2 standar-plus-table">
                          <div class="form-group" v-if="cob.SUMAS.length === 1">
                            {{ cob.SUMAS[0].DESCRIPCION }}
                          </div>
                          <div
                            class="form-group d-flex align-items-center"
                            v-if="cob.SUMAS.length > 1"
                          >
                            <label class="mr-2">Suma Asegurada</label>
                            <select
                              class="form-control"
                              v-model="cob.checkSumas"
                              @change="changeBasicaSumas($event, c)"
                              :disabled="
                                cob.NOMENCLATURA === 'DM' ||
                                  cob.NOMENCLATURA === 'RT'
                              "
                            >
                              <option
                                v-for="(ded, ind) in cob.SUMAS"
                                :key="ind"
                                :value="ded.VALOR"
                                :selected="ded.VALOR === cob.checkSumas"
                              >
                                {{ formatMoney(ded.DESCRIPCION) }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3 col-sm-12 mt-2 standar-plus-table">
                          <div
                            class="form-group mt-4"
                            v-if="cob.DEDUCIBLES.length === 1"
                          >
                            {{ cob.DEDUCIBLES[0].DESCRIPCION }}
                          </div>
                          <div
                            class="form-group d-flex align-items-center"
                            v-if="cob.DEDUCIBLES.length > 1"
                          >
                            <select
                              class="form-control"
                              v-model="cob.checkDeducibles"
                              @change="changeBasicaDeducible($event, c)"
                            >
                              <option
                                v-for="(ded, ind) in cob.DEDUCIBLES"
                                :key="ind"
                                :value="ded.VALOR"
                                :selected="ded.VALOR === cob.checkDeducibles"
                              >
                                {{ Math.trunc(ded.DESCRIPCION) }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div
                      :id="`flush-collapse${c}`"
                      class="accordion-collapse collapse"
                      :aria-labelledby="`flush-heading${c}`"
                      :data-bs-parent="`#accordionFlush${ind}`"
                    >
                      <div class="accordion-body">
                        <div class="row responsive-plus">
                          <div class="col-md-12">
                            <div
                              class="form-group"
                              v-if="cob.SUMAS.length === 1"
                            >
                              {{ cob.SUMAS[0].DESCRIPCION }}
                            </div>
                            <div
                              class="form-group d-flex align-items-center"
                              v-if="cob.SUMAS.length > 1"
                            >
                              <label class="mr-2">Suma Asegurada</label>
                              <select
                                class="form-control"
                                v-model="cob.checkSumas"
                                @change="changeBasicaSumas($event, c)"
                                :disabled="
                                  cob.NOMENCLATURA === 'DM' ||
                                    cob.NOMENCLATURA === 'RT'
                                "
                              >
                                <option
                                  v-for="(ded, ind) in cob.SUMAS"
                                  :key="ind"
                                  :value="ded.VALOR"
                                  :selected="ded.VALOR === cob.checkSumas"
                                >
                                  {{ formatMoney(ded.DESCRIPCION) }}
                                </option>
                              </select>
                            </div>

                            <div
                              class="form-group mt-4"
                              v-if="cob.DEDUCIBLES.length === 1"
                            >
                              {{ cob.DEDUCIBLES[0].DESCRIPCION }}
                            </div>
                            <div
                              class="form-group d-flex align-items-center"
                              v-if="cob.DEDUCIBLES.length > 1"
                            >
                              <select
                                class="form-control"
                                v-model="cob.checkDeducibles"
                                @change="changeBasicaDeducible($event, c)"
                              >
                                <option
                                  v-for="(ded, ind) in cob.DEDUCIBLES"
                                  :key="ind"
                                  :value="ded.VALOR"
                                  :selected="ded.VALOR === cob.checkDeducibles"
                                >
                                  {{ Math.trunc(ded.DESCRIPCION) }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            {{ cob.DESCRIP }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="customCobs">
          <div v-for="(paq, ind) in allCobs" :key="ind" class="mb-4">
            <div v-if="paq.MODEL">
              <div
                class="accordion accordion-flush"
                :id="`accordionFlush${ind}`"
                v-if="paq.MODEL"
              >
                <div v-for="(cob, c) in paq.COBERTURAS" :key="c">
                  <div
                    class="accordion-item"
                    v-if="cob.OPCIONAL === 1 && cob.TIPO === 3"
                  >
                    <h2 class="accordion-header" :id="`flush-heading${c}`">
                      <button
                        class="accordion-button collapsed row"
                        type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="`#flush-collapse${c}`"
                        aria-expanded="false"
                        :aria-controls="`flush-collapse${c}`"
                      >
                        <div class="col-md-4 col-sm-12">
                          <div class="round">
                            <input
                              :id="`checkbox${c}`"
                              type="checkbox"
                              name="active"
                              v-model="cob.check"
                              @change="calculateCob($event, c)"
                            />
                            <label
                              :for="`checkbox${c}`"
                              class="label-checkbox"
                            ></label>
                            <label class="label-text">{{
                              cob.DESCRIPCIONCOBERTURA
                            }}</label>
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-12 standar-plus-table">
                          <div
                            class="form-group mt-4"
                            v-if="cob.SUMAS.length === 1"
                          >
                            {{ formatMoney(cob.SUMAS[0].DESCRIPCION) }}
                          </div>
                          <div
                            class="form-group d-flex"
                            v-if="cob.SUMAS.length > 1"
                          >
                            <label class="mr-2 mt-4">Suma Asegurada</label>
                            <select
                              class="form-control mt-4"
                              v-model="cob.checkSumas"
                              @change="changeBasicaSumas($event, c)"
                            >
                              <option
                                v-for="(ded, ind) in cob.SUMAS"
                                :key="ind"
                                :value="ded.VALOR"
                                :selected="ded.VALOR === cob.checkSumas"
                              >
                                {{ formatMoney(ded.DESCRIPCION) }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3 col-sm-12 standar-plus-table">
                          <div
                            class="form-group"
                            v-if="cob.DEDUCIBLES.length === 1"
                          >
                            {{ cob.DEDUCIBLES[0].DESCRIPCION }}
                          </div>
                          <div
                            class="form-group d-flex"
                            v-if="cob.DEDUCIBLES.length > 1"
                          >
                            <label class="mr-2">Deducible</label>
                            <select
                              class="form-control"
                              v-model="cob.checkDeducibles"
                              @change="changeBasicaDeducible($event, c)"
                            >
                              <option
                                v-for="(ded, ind) in cob.DEDUCIBLES"
                                :key="ind"
                                :value="ded.VALOR"
                                :selected="ded.VALOR === cob.checkDeducibles"
                              >
                                {{ Math.trunc(ded.DESCRIPCION) }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div
                      :id="`flush-collapse${c}`"
                      class="accordion-collapse collapse"
                      :aria-labelledby="`flush-heading${c}`"
                      :data-bs-parent="`#accordionFlush${ind}`"
                    >
                      <div class="accordion-body">
                        <div class="row responsive-plus">
                          <div class="col-12">
                            <div
                              class="form-group mt-4"
                              v-if="cob.SUMAS.length === 1"
                            >
                              {{ formatMoney(cob.SUMAS[0].DESCRIPCION) }}
                            </div>
                            <div
                              class="form-group d-flex"
                              v-if="cob.SUMAS.length > 1"
                            >
                              <label class="mr-2 mt-4">Suma Asegurada</label>
                              <select
                                class="form-control mt-4"
                                v-model="cob.checkSumas"
                                @change="changeBasicaSumas($event, c)"
                              >
                                <option
                                  v-for="(ded, ind) in cob.SUMAS"
                                  :key="ind"
                                  :value="ded.VALOR"
                                  :selected="ded.VALOR === cob.checkSumas"
                                >
                                  {{ formatMoney(ded.DESCRIPCION) }}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div
                            class="form-group"
                            v-if="cob.DEDUCIBLES.length === 1"
                          >
                            {{ cob.DEDUCIBLES[0].DESCRIPCION }}
                          </div>
                          <div
                            class="form-group d-flex"
                            v-if="cob.DEDUCIBLES.length > 1"
                          >
                            <label class="mr-2">Deducible</label>
                            <select
                              class="form-control"
                              v-model="cob.checkDeducibles"
                              @change="changeBasicaDeducible($event, c)"
                            >
                              <option
                                v-for="(ded, ind) in cob.DEDUCIBLES"
                                :key="ind"
                                :value="ded.VALOR"
                                :selected="ded.VALOR === cob.checkDeducibles"
                              >
                                {{ Math.trunc(ded.DESCRIPCION) }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            {{ cob.DESCRIP }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section v-if="customCobs">
          <h3 class="mt-1 mb-4 text-primary title fw-bold">
            Agrega un plus a su protección
          </h3>

          <div class="row">
            <div class="col-12 pt-1">
              <VueHorizontalList
                :items="filterCoberturas()"
                :options="{
                  responsive: [
                    { end: 576, size: 1 },
                    { start: 576, end: 768, size: 2 },
                    { size: 3 },
                  ],
                }"
              >
                <template v-slot:default="{ item }">
                  <div class="item">
                    <Card
                      class="animate__animated animate__fadeInUp"
                      :data="item"
                      :title="item.DESCRIPCIONCOBERTURA"
                      :desc="item.DESCRIP"
                      :name="item.NOMENCLATURA"
                      :deducible="
                        item.DEDUCIBLES.length > 0
                          ? item.DEDUCIBLES[0].VALOR
                          : 0
                      "
                      :suma="item.SUMAS.length > 0 ? item.SUMAS[0].VALOR : 0"
                      :cost="
                        item.valor === 0
                          ? item.valor.toString()
                          : formatMoney(item.valor)
                      "
                      :radio="item.check"
                      :orden="item.ORDEN"
                      :updateSuma="updateSumaCobertura"
                      :modalDescripcionCobertura="modalDescripcionCobertura"
                    />
                  </div>
                </template>
              </VueHorizontalList>
              <span class="responsive-plus"
                >Desliza hacia la derecha para conocer nuestras
                asistencias</span
              >
            </div>
          </div>
        </section>

        <div class="row">
          <div class="col-md-12">
            <h6
              class="fw-bold"
              style="color: #29abe2 !important"
              v-if="!customCobs"
            >
              Si estás de acuerdo con el paquete, da clic en el botón siguiente
              para obtener la cotización e iniciar la contratación o bien...
              Personaliza su seguro.
            </h6>
          </div>
          <div class="col-md-12 d-flex justify-content-end mt-3 standar-plus">
            <button
              v-if="!customCobs"
              type="button"
              class="btn btn-info mr-2 btn-rounded btn-sm"
              @click="customCobs = true"
            >
              Personalizar
            </button>
            <button
              v-if="!customCobs"
              type="button"
              class="btn btn-outline-primary mr-2 btn-rounded btn-sm"
              @click="handleNavigation(1)"
            >
              Regresar
            </button>
            <button
              v-if="customCobs"
              type="button"
              class="btn btn-outline-primary mr-2 btn-rounded btn-sm"
              @click="customCobs = false"
            >
              Regresar
            </button>
            <button
              type="button"
              class="btn btn-primary btn-rounded btn-sm"
              @click="handleNavigation(3)"
              :disabled="!validAnySelectedCob"
            >
              Siguiente
            </button>
          </div>
          <div class="row d-flex justify-content-end mt-3 responsive-plus">
            <div class="col-md-4 mt-2">
              <button
                v-if="!customCobs"
                type="button"
                class="btn btn-info mr-2 btn-rounded btn-sm w-100"
                @click="customCobs = true"
              >
                Personalizar
              </button>
            </div>
            <div class="col-md-4 mt-2">
              <button
                v-if="!customCobs"
                type="button"
                class="btn btn-outline-primary mr-2 btn-rounded btn-sm w-100"
                @click="handleNavigation(1)"
              >
                Regresar
              </button>
              <button
                v-if="customCobs"
                type="button"
                class="btn btn-outline-primary mr-2 btn-rounded btn-sm w-100"
                @click="customCobs = false"
              >
                Regresar
              </button>
            </div>
            <div class="col-md-4 mt-2">
              <button
                type="button"
                class="btn btn-primary btn-rounded btn-sm w-100"
                @click="handleNavigation(3)"
                :disabled="!validAnySelectedCob"
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.round {
  position: relative;
}

.round .label-checkbox {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 28px;
  left: 0;
  position: absolute;
  top: 0;
  width: 28px;
}

.round .label-checkbox:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 7px;
  opacity: 0;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + .label-checkbox {
  background-color: #66bb6a;
  border-color: #66bb6a;
}

.round input[type="checkbox"]:checked + .label-checkbox:after {
  opacity: 1;
}

.round .label-text {
  margin-left: 30px !important;
  font-size: 12px !important;
}

.accordion-item {
  border-bottom: 1px solid !important;
  border-color: rgba(0, 0, 21, 0.2) !important;
}

.font-label {
  font-size: 12px !important;
}

@media only screen and (max-width: 768px) {
  .icon-car {
    display: none !important;
  }
}

.left {
  float: left;
}

.center {
  float: left;
  overflow: hidden;
  white-space: nowrap;
}

.right {
  float: right;
}

@media (max-width: 767px) {
  .responsive-plus {
    display: flex !important;
  }

  .standar-plus {
    display: none !important;
  }

  .standar-plus-table {
    display: none !important;
  }

  .internal {
    display: inline-block;
    width: 90% !important;
  }

  .c-main {
    padding-top: 0rem !important;
  }
}

@media (min-width: 768px) {
  .responsive-plus {
    display: none !important;
  }

  .standar-plus {
    display: flex !important;
  }

  .standar-plus-table {
    display: table !important;
  }

  .internal {
    display: inline-block;
    width: 72% !important;
  }
}
</style>

<script>
import { format, date } from "../../../../assets/helpers";
import icons from "./../../tools/icons.sample";
import Card from "./../../tools/Card.vue";
import CardRadioPlan from "./../../tools/CardRadioPlan.vue";
import VueHorizontalList from "vue-horizontal-list";
import { enableLoading } from "../../../../store/actions/ModuloActions";

export default {
  components: {
    Card,
    CardRadioPlan,
    VueHorizontalList,
  },
  props: {
    modelo: String,
    version: String,
    payload: Object,
    payloadCobs: Array,
    apistate: null,
    selectedPlan: Number,
    allCobs: Array,
    total: Number,
  },
  data() {
    return {
      icons,
      cobs: [],
      extraCobs: [],
      selectedCobs: [],
      basicCobs: ["DMPP", "DMPT", "RT"],
      totalAmount: 0,
      totalDescuentos: null,
      modalInfo: false,
      informacionCobertura: "",
      myIcon: "",
      customCobs: false,
      scoreBuroCredito: "-008",
    };
  },
  methods: {
    async handleNavigation(to) {
      if (to == 1) {
        const shouldGoBack = await this.$swal({
          title: "¿Desea modificar los datos?",
          text: "",
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Regresar",
          denyButtonText: "Permanecer aquí",
        });

        if (!shouldGoBack.isConfirmed) {
          return;
        }

        this.$emit("update:allCobs", []);
        this.$emit("update:selectedPlan", 0);
        return this.$emit("onChangeStep", to, "basicas", []);
      }

      this.$emit("onChangeStep", to, "basicas", []);
    },
    setBasicCobsRules() {
      const comercialVal = "VALOR COMERCIAL";
      const selectsSA = this.basicCobs.map((cob) =>
        document.querySelector(`.${cob} [name='sa']`)
      );
      const selectsDED = this.basicCobs.map((cob) =>
        document.querySelector(`.${cob} [name='deducible']`)
      );

      selectsSA.pop();
      selectsDED.pop();

      selectsSA.forEach((select) => {
        const innerText = select.selectedOptions[0].innerText.trim();

        if (innerText == comercialVal) {
          selectsSA.forEach((select) => {
            const options = select.querySelectorAll("option");
            options.forEach((option) => {
              if (option.innerText.trim() == comercialVal) {
                option.setAttribute("selected", true);
              }
            });
          });
        }
      });

      selectsDED.forEach((select) => {
        let selectValue = null;

        if (select.value != "") {
          selectValue = select.value.trim();
        }

        if (selectValue) {
          selectsDED.forEach((item) => {
            const options = item.querySelectorAll("option");
            options.forEach((option) => {
              if (option.innerText.trim() == selectValue) {
                option.setAttribute("selected", true);
              }
            });
          });
        }
      });
    },
    getSelectedCobs() {
      const table = document.querySelector("#tbody-cobs");
      const checks = table.querySelectorAll("[type='checkbox']:checked");
      const validCobs = [];

      checks.forEach((check) => {
        const row = check.parentElement.parentElement;
        const sa = row.querySelector("[name='sa']");
        const ded = row.querySelector("[name='deducible']");
        validCobs.push({
          active: true,
          id: row.getAttribute("data-id"),
          sa: sa.value,
          deducible: ded ? ded.value : "NA",
          costo: row.getAttribute("data-costo") || "0",
        });
      });

      if (!validCobs.length) {
        return [];
      }

      return validCobs.filter((cobs) =>
        Object.values(cobs).every((value) => value)
      );
    },
    async getCostoCobertura(cobertura, deducible, suma) {
      const rcTemp = this.allCobs[this.selectedPlan].COBERTURAS.find(
        (cob) => cob.NOMENCLATURA === "RC"
      );
      const sumaTemp = cobertura === "ERC" ? rcTemp.checkSumas : suma;

      const cobTemp = this.allCobs[this.selectedPlan].COBERTURAS.find(
        (cob) => cob.NOMENCLATURA === cobertura
      );
      const sumCobTemp = cobTemp.SUMAS.find((sum) => sum.VALOR === suma);

      const {
        version,
        modelo,
        universe,
        universe2,
        km,
        vig_ini,
        vig_fin,
        tipoVigencia,
        agente,
      } = this.payload;

      const payload = {
        metodo: "GET_CALCULO_COBS_CA",
        data: {
          ClaveVehiculo: version,
          ModeloVehiculo: modelo,
          ClaveCobertura: cobertura,
          SumaAsegurada: sumaTemp,
          ValorAuto: this.getValorAuto(
            sumCobTemp.DESCRIPCION,
            sumCobTemp.VALOR
          ),
          Deducible: deducible == "NA" ? "" : deducible,
          EstadoUniverse: universe || universe2,
          PorcentajeDescuento: this.totalDescuentos,
          Kilometraje: km ? +km.replaceAll(",", "") : 0,
          ClaveAgente: agente,
          primaDmpt: this.getPrima("DMPT"),
          primaDmpp: this.getPrima("DM"),
          primaRoboTotal: this.getPrima("RT"),
          primaRespCivil: this.getPrima("RC"),
          primaGastosMedico: this.getPrima("GM"),
          deducibleDMPP: this.getDeducible("DM"),
          deducibleDMPT: this.getDeducible("DMPT"),
          deducibleRT: this.getDeducible("RT"),
          VigenciaInicio: format.date(vig_ini, "dd/mm/aaaa"),
          VigenciaFin: format.date(vig_fin, "dd/mm/aaaa"),
          TipoVigencia: tipoVigencia,
          BuroCredito: this.scoreBuroCredito,
          TIPOMOVIMIENTO: "",
          PRIMACOBERTURA: 0
        },
      };

      return await this.$store
        .dispatch("metodoPost", payload)
        .then(() => this.$store.getters.getRespuestaREST);
    },
    getValorAuto(descripcion, valor) {
      const { monto_factura } = this.payload;
      const valorFactura = monto_factura
        ? +monto_factura.replaceAll(",", "")
        : 0;

      switch (descripcion) {
        case "VALOR FACTURA":
          return valorFactura;
        case "VALOR CONVENIDO":
          return valor;
        case "VALOR COMERCIAL":
          return 0;
        default:
          return valorFactura;
      }
    },
    formatMoney(amount) {
      if (isNaN(amount)) {
        return amount;
      }
      return format.money(amount, false);
    },
    getDeducible(id) {
      let cobertura = [];

      if (this.allCobs.length > 0) {
        cobertura = this.allCobs[this.selectedPlan].COBERTURAS.find(
          (cob) => cob.NOMENCLATURA == id
        );
      }

      if (!cobertura) {
        return "";
      }
      return cobertura.checkDeducibles;
    },
    getPrima(id) {
      let cobertura = [];

      if (this.allCobs.length > 0) {
        cobertura = this.allCobs[this.selectedPlan].COBERTURAS.find(
          (cob) => cob.NOMENCLATURA == id
        );
      }

      if (!cobertura) {
        return "";
      }
      return cobertura.valor;
    },
    shouldValorFactura(id) {
      return (
        this.basicCobs.some((basic) => basic == id) &&
        this.payload.monto_factura
      );
    },
    async getScoreProspecto() {
      const {
        cp,
        apaterno,
        amaterno,
        fullname,
        fecha_nac,
        sexo,
      } = this.payload;

      const payload = {
        metodo: "GETSCOREPROSPECTO",
        data: {
          consulta: {
            persona: {
              domicilios: [
                {
                  ciudad: "",
                  codPais: "",
                  coloniaPoblacion: "",
                  cp: cp,
                  delegacionMunicipio: "",
                  direccion1: "",
                  direccion2: "",
                  estado: "",
                  extension: "",
                  fax: "",
                  fechaResidencia: "",
                  indicadorEspecialDomicilio: "",
                  numeroTelefono: "",
                  tipoDomicilio: "",
                },
              ],
              nombre: {
                apellidoAdicional: "",
                apellidoMaterno: amaterno,
                apellidoPaterno: apaterno,
                claveImpuestosOtroPais: "",
                claveOtroPais: "",
                edadesDependientes: "",
                estadoCivil: "",
                fechaNacimiento: format.date(fecha_nac, "dd/mm/aaaa"),
                nacionalidad: "",
                numeroCedulaProfesional: "",
                numeroDependientes: "",
                numeroLicenciaConducir: "",
                numeroRegistroElectoral: "",
                prefijo: "",
                primerNombre: fullname,
                residencia: "",
                rfc: "",
                segundoNombre: "",
                sexo: sexo,
                sufijo: "",
              },
            },
          },
        },
      };

      await this.$store.dispatch("metodoPost", payload).then((_) => {
        const response = this.$store.getters.getRespuestaREST;

        if (!response.respuesta.persona.error) {
          this.scoreBuroCredito = response.respuesta.persona.scoreBuroCredito[0].valorScore;
        }
      });
    },
    async getCobs() {
      if (this.allCobs.length > 0) {
        return;
      }

      const {
        version,
        modelo,
        universe,
        universe2,
        km,
        vig_ini,
        vig_fin,
        tipoVigencia,
        monto_factura,
        tipoValor,
      } = this.payload;

      const payload = {
        metodo: "OBTENERCOBERTURASPAQUETES",
        data: {
          ClaveVehiculo: version,
          ModeloVehiculo: modelo,
          IdUsuario: localStorage.getItem("userId"),
          TipoCotizador: 2,
          ValorAuto: monto_factura || 0,
          EstadoUniverse: universe || universe2,
          PorcentajeDescuento: this.totalDescuentos,
          Kilometraje: km ? +km.replaceAll(",", "") : 0,
          VigenciaInicio: format.date(vig_ini, "dd/mm/aaaa"),
          VigenciaFin: format.date(vig_fin, "dd/mm/aaaa"),
          TipoVigencia: tipoVigencia,
          TipoValor: tipoValor,
          BuroCredito: this.scoreBuroCredito,
        },
      };

      await this.$store.dispatch("metodoPost", payload).then((_) => {

        const planes = this.$store.getters.getRespuestaREST;

        planes.map((paq, index) => {
          paq.MODEL = index === 0;
          paq.TOTAL = 0;
          paq.TOTALPAQUETE = 0;
          paq.TOTALCOBEXTRA = 0;

          paq.COBERTURAS.sort((a, b) => a.ORDEN - b.ORDEN);

          paq.COBERTURAS.map((cob) => {
            cob.check = cob.OPCIONAL === 0;
            cob.PRIMA = cob.NOMENCLATURA === "RCU" ? 0 : cob.PRIMA;
            cob.valor = cob.NOMENCLATURA === "RCU" ? 0 : cob.PRIMA;
            cob.checkSumas =
              modelo === "2022" &&
              monto_factura !== "" &&
              this.verifyTypesSums(cob.SUMAS)
                ? 0
                : cob.SUMADEFAULT;
            cob.checkDeducibles = cob.DEDUDEFAULT;
            paq.TOTAL =
              cob.OPCIONAL === 0 ? paq.TOTAL + cob.PRIMA : paq.TOTAL + 0;
            paq.TOTALPAQUETE =
              cob.OPCIONAL === 0
                ? paq.TOTALPAQUETE + cob.PRIMA
                : paq.TOTALPAQUETE + 0;

            this.$emit("update:total", +planes[0].TOTAL.toFixed(2));
          });
        });

        this.$emit("update:allCobs", planes);

        this.$store.dispatch("disabledLoading").then((_) => {});
      });
    },
    verifyTypesSums(sumas) {
      const response = sumas.findIndex(
        (sum) =>
          sum.DESCRIPCION === "VALOR COMERCIAL" ||
          sum.DESCRIPCION === "VALOR FACTURA" ||
          sum.DESCRIPCION === "VALOR CONVENIDO"
      );
      return response !== -1;
    },
    async getDescuentos() {
      const { version, sexo, fecha_nac, km } = this.payload;
      const payload = {
        metodo: "GET_DESCUENTOS_CA",
        data: {
          Genero: sexo,
          Edad: date.getAge(format.date(fecha_nac, "aaaa/mm/dd")),
          ClaveVehiculo: version,
          Kilometraje: km ? +km.replaceAll(",", "") : 0,
        },
      };

      await this.$store.dispatch("metodoPost", payload);
      const descuentos = this.$store.getters.getRespuestaREST.map(
        (descuento) => descuento.ValorInicio
      );
      this.totalDescuentos = descuentos.join("-");
    },
    validAnySelectedCob(id = null) {
      if (id) {
        const cob = this.selectedCobs.find((item) => item.id == id);
        if (!cob) {
          return false;
        }
        return Object.values(cob).every((value) => value && value != "");
      }

      this.selectedCobs = [];

      const selected = this.selectedCobs.filter((cob) =>
        Object.values(cob).every((value) => value != false)
      );

      if (!selected.length) {
        return false;
      }
      return selected;
    },
    fillData() {
      if (this.apistate.cobs) {
        const { basicas, extras } = this.apistate.cobs;
        if (basicas) {
          this.cobs = basicas;
        }
        if (extras) {
          this.extraCobs = extras;
        }

        setTimeout(() => {
          if (!this.payloadCobs) {
            return;
          }
          this.payloadCobs.forEach((cob) => {
            const element = document.querySelector(`.${cob.id}`);
            if (element) {
              element.setAttribute("data-costo", cob.costo);
              element.querySelector("[type='checkbox']").checked = true;
              element.querySelector("[name='sa']").value = cob.sa;

              if (!this.shouldValorFactura(cob.id)) {
                element
                  .querySelector("[name='sa']")
                  .removeAttribute("disabled");
              }

              const deducibleElement = element.querySelector(
                "[name='deducible']"
              );
              if (deducibleElement) {
                deducibleElement.value = cob.deducible;
                deducibleElement.removeAttribute("disabled");
              }
            }
          });
          // this.setBasicCobsRules();
        }, 500);
      }
    },
    handleTotalCobs() {
      this.selectedCobs = [];
      if (!this.selectedCobs.length) {
        this.totalAmount = 0;
        this.extraCobs = [];
      } else {
        this.totalAmount = this.selectedCobs.reduce(
          (last, current) => Number(current.costo) + last,
          0
        );
      }
    },
    showModalInformacion(desc) {
      this.informacionCobertura = desc;
      this.modalInfo = true;
    },
    changePackage(index) {
      this.$emit("update:selectedPlan", index);

      let cobs = [...this.allCobs];
      cobs.map((cob, ind) => (cob.MODEL = ind === index));

      this.$emit("update:allCobs", cobs);
      this.$emit("update:total", +this.allCobs[index].TOTAL.toFixed(2));
    },
    changeBasicaDeducible(event, i) {
      console.log([i, this.selectedPlan]);
      const cob = this.allCobs[this.selectedPlan].COBERTURAS[i];
      console.log(cob);
      if (cob.check) {
        this.getCostoCobertura(
          cob.NOMENCLATURA,
          cob.checkDeducibles,
          cob.checkSumas
        ).then(
          (val) => {
            this.allCobs[this.selectedPlan].COBERTURAS[i].valor = val[0]
              ? val[0]
              : 0;
            this.updateSumaGeneral();
          },
          (error) => console.log(error)
        );
      }
    },
    changeBasicaSumas(event, i) {
      if (this.changeSelectsSums(i) <= 0) {
        const cob = this.allCobs[this.selectedPlan].COBERTURAS[i];
        if (cob.check) {
          this.getCostoCobertura(
            cob.NOMENCLATURA,
            cob.checkDeducibles,
            cob.checkSumas
          ).then(
            (val) => {
              this.allCobs[this.selectedPlan].COBERTURAS[i].valor = val[0]
                ? val[0]
                : 0;
              this.updateSumaGeneral();
            },
            (error) => console.log(error)
          );
        }
      }
    },
    updateSumaGeneral() {
      let tempTotal = 0;
      let tempTotalPaquete = 0;
      let tempTotalCobExtra = 0;
      let tempCobs = [...this.allCobs];

      tempCobs[this.selectedPlan].COBERTURAS.map((cob) => {
        if (cob.check) {
          if (cob.OPCIONAL === 0) {
            tempTotalPaquete = tempTotalPaquete + cob.valor;
          } else if (cob.OPCIONAL === 1) {
            tempTotalCobExtra = tempTotalCobExtra + cob.valor;
          }

          tempTotal = tempTotal + cob.valor;
        }
      });

      tempCobs[this.selectedPlan].TOTAL = tempTotal;
      tempCobs[this.selectedPlan].TOTALPAQUETE = tempTotalPaquete;
      tempCobs[this.selectedPlan].TOTALCOBEXTRA = tempTotalCobExtra;

      this.$emit("update:allCobs", tempCobs);
      this.$emit("update:total", +tempTotal.toFixed(2));
    },
    calculateCob(e, index) {
      const cob = this.allCobs[this.selectedPlan].COBERTURAS[index];
      const cobExtra = this.allCobs[this.selectedPlan].COBERTURAS.find(
        (cob) => cob.NOMENCLATURA === "AIP"
      );

      if (cob.NOMENCLATURA === "AI") {
        cobExtra.check = !cob.check;
        this.updateSumaGeneral();

        this.$swal(
          "Advertencia",
          !cob.check
            ? "Ahora estas protegido con asistencia Vial Plus"
            : "Continúas protegido con Asistencia Vial, se incluye en tu paquete"
        );
      }

      this.getCostoCobertura(
        cob.NOMENCLATURA,
        cob.checkDeducibles,
        cob.checkSumas
      ).then(
        (val) => {
          this.allCobs[this.selectedPlan].COBERTURAS[index].valor = val[0]
            ? val[0]
            : 0;
          this.updateSumaGeneral();
        },
        (error) => console.log(error)
      );
    },
    changeSelectsSums(i) {
      const cobsTemp = [...this.allCobs];

      const filters = cobsTemp[this.selectedPlan].COBERTURAS.filter(
        (cob) =>
          cob.SUMAS.findIndex(
            (sum) =>
              sum.VALOR ===
                this.allCobs[this.selectedPlan].COBERTURAS[i].checkSumas &&
              (sum.DESCRIPCION === "VALOR COMERCIAL" ||
                sum.DESCRIPCION === "VALOR CONVENIDO" ||
                sum.DESCRIPCION === "VALOR FACTURA")
          ) > -1
      ).map((cob, ind) => {
        cob.checkSumas = this.allCobs[this.selectedPlan].COBERTURAS[
          i
        ].checkSumas;

        if (cob.check) {
          this.getCostoCobertura(
            cob.NOMENCLATURA,
            cob.checkDeducibles,
            cob.checkSumas
          ).then(
            (val) => {
              this.allCobs[this.selectedPlan].COBERTURAS[ind].valor = val[0]
                ? val[0]
                : 0;
              this.updateSumaGeneral();
            },
            (error) => console.log(error)
          );
        } else {
          this.updateSumaGeneral();
        }
      });

      this.$emit("update:allCobs", cobsTemp);

      return filters.length;
    },
    filterCoberturas() {
      return this.allCobs.length > 0
        ? this.allCobs[this.selectedPlan].COBERTURAS.filter(
            (cob) => cob.OPCIONAL === 1 && cob.TIPO === 2
          )
        : [];
    },
    updateSumaCobertura(check, nomenclatura, deducible, suma) {
      const cob = this.allCobs[this.selectedPlan].COBERTURAS.find(
        (cob) => cob.NOMENCLATURA === "AI"
      );

      if (nomenclatura === "AIP") {
        cob.check = !check;
        this.updateSumaGeneral();

        this.$swal(
          "Advertencia",
          !check
            ? "Ahora estas protegido con asistencia Vial Plus"
            : "Continúas protegido con Asistencia Vial, se incluye en tu paquete"
        );
      }

      const tempCobs = [...this.allCobs];

      const exists = tempCobs[this.selectedPlan].COBERTURAS.findIndex(
        (cob) => cob.NOMENCLATURA === nomenclatura
      );

      if (nomenclatura === "AFC" && check) {
        const cob = tempCobs[this.selectedPlan].COBERTURAS.find(
          (cob) => cob.check && cob.NOMENCLATURA === "AFO"
        );
        if (cob !== undefined) {
          document.getElementById(`check${cob.ORDEN}`).click();
        }
      } else if (nomenclatura === "AFO" && check) {
        const cob = tempCobs[this.selectedPlan].COBERTURAS.find(
          (cob) => cob.check && cob.NOMENCLATURA === "AFC"
        );
        if (cob !== undefined) {
          document.getElementById(`check${cob.ORDEN}`).click();
        }
      }

      if (exists !== -1) {
        tempCobs[this.selectedPlan].COBERTURAS[exists].check = check;
      }

      if (check && nomenclatura !== "RCU") {
        this.getCostoCobertura(nomenclatura, deducible, suma).then(
          (val) => {
            const valor = val[0] ? val[0] : 0;
            tempCobs[this.selectedPlan].COBERTURAS[exists].valor = valor;
            tempCobs[this.selectedPlan].TOTAL =
              tempCobs[this.selectedPlan].TOTAL + valor;

            this.$emit("update:allCobs", tempCobs);
            this.updateSumaGeneral();
          },
          (error) => console.log(error)
        );
      } else {
        this.updateSumaGeneral();
      }
    },
    modalDescripcionCobertura() {},
    getCobSelect() {
      return this.allCobs.filter((cob) => cob.MODEL);
    },

    // Horizontal Scroll

    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft;
      // Condition to check if scrolling is required
      if (
        !(
          (scrollPos === 0 || scrollPixels > 0) &&
          (element.clientWidth + scrollPos === element.scrollWidth ||
            scrollPixels < 0)
        )
      ) {
        // Get the start timestamp
        const startTime =
          "now" in window.performance
            ? performance.now()
            : new Date().getTime();

        function scroll(timestamp) {
          //Calculate the timeelapsed
          const timeElapsed = timestamp - startTime;
          //Calculate progress
          const progress = Math.min(timeElapsed / duration, 1);
          //Set the scrolleft
          element.scrollLeft = scrollPos + scrollPixels * progress;
          //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
          if (timeElapsed < duration) {
            //Request for animation
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        }
        //Call requestAnimationFrame on scroll function first time
        window.requestAnimationFrame(scroll);
      }
    },
    swipeLeft() {
      const content = this.$refs.content;
      this.scrollTo(content, -300, 800);
    },
    swipeRight() {
      const content = this.$refs.content;
      this.scrollTo(content, 300, 800);
    },
  },

  async mounted() {

    await this.getDescuentos();
    this.fillData();
    setTimeout(() => this.handleTotalCobs(), 500);
    this.$emit("onMounted", "basicas");
    await this.getScoreProspecto();
    await this.getCobs();

    const iconRoute = this.icons.find((icon) => icon.name == "RCZ");
    this.myIcon = iconRoute.image;
  },
};
</script>
